module.exports = __webpack_public_path__ + "static/media/feature-agility.ed260f2e.png";